import { createAsyncThunk, isRejected } from '@reduxjs/toolkit';
import {
  actions as appStorageActions,
  constants as appStorageConstants,
  utils as appStorageUtils,
} from '@saucelabs/sl-module-app-storage';

import types from './types';
import constants from './constants';

type FetchAppStorageFilesArguments = {
  fileId?: string;
  searchQuery?: string;
  shouldCancelPreviousRequest?: boolean;
}
const fetchAppStorageFiles = createAsyncThunk(
  types.MOBILE_APP_SELECTION_FETCH_FILES,
  async (requestFilter: FetchAppStorageFilesArguments, { dispatch, rejectWithValue }) => {
    try {
      const fetchFilesResponse = await dispatch(appStorageActions.fetchFiles({
        entriesPerPage: constants.FETCH_FILES_PAGE_SIZE,
        iconRepresentation: appStorageConstants.APP_STORAGE_ICON_REPRESENTATION.hash,
        ...requestFilter,
      }));

      if (isRejected(fetchFilesResponse)) {
        const serverError = fetchFilesResponse.payload as appStorageUtils.SerializedApiError;
        throw serverError;
      }

      return fetchFilesResponse.payload;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      if (error instanceof Error) {
        return rejectWithValue(appStorageUtils.handleApiError(error));
      }

      return rejectWithValue(error);
    }
  },
);

export default {
  fetchAppStorageFiles,
};
